<template>
  <div class="expManage">
    <el-divider content-position="left">快递信息列表</el-divider>
    <div style="display: flex; margin-bottom: 0.2rem">
      <el-select
        v-model="searchArr.company_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入公司名称筛选公司"
        size="mini"
        clearable
        :remote-method="searchRemoteCompanyMethod"
        :loading="searchLoading"
        @change="handleSearchCompanyChange"
      >
        <el-option
          v-for="searchCompany in searchCompanies"
          :key="searchCompany.id"
          :label="searchCompany.company_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="searchArr.exp_num"
        filterable
        remote
        reserve-keyword
        placeholder="快递单号"
        size="mini"
        clearable
        :remote-method="searchRemoteexp_numMethod"
        :loading="exp_numLoading"
        @change="handleSearchExp_numChange"
        style="margin-left: 10px"
      >
        <el-option
          v-for="item in exp_numArr"
          :key="item.id"
          :label="item.exp_num"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-popover
        placement="bottom"
        v-model="visible"
        width="570"
        style="margin-left: 10px"
      >
        <el-form
          :model="searchArr"
          ref="searchForm"
          label-width="100px"
          style="padding-right: 0.63rem"
        >
          <div style="display: inline-block; width: 290px">
            <div style="text-align: center; margin-left: 80px">基础筛选</div>
            <el-form-item label="快递公司" prop="exp_company">
              <el-select
                v-model="searchArr.exp_company"
                placeholder="请选择快递公司"
                size="mini"
                clearable
              >
                <el-option value="SFEXPRESS" label="顺丰"></el-option>
                <el-option value="STO" label="申通"></el-option>
                <el-option value="YTO" label="圆通"></el-option>
                <el-option value="ZTO" label="中通"></el-option>
                <el-option value="HTKY" label="汇通"></el-option>
                <el-option value="YUNDA" label="韵达"></el-option>
                <el-option value="TTKDEX" label="天天"></el-option>
                <el-option value="JD" label="京东快递"></el-option>
                <el-option value="ZJS" label="宅急送"></el-option>
                <el-option value="CHINAPOST" label="EMS"></el-option>
                <el-option value="INTMAIL" label="EMS国际"></el-option>
                <el-option value="DEPPON" label="德邦"></el-option>
                <el-option value="HTKY" label="百世快递"></el-option>
                <el-option value="JITU" label="极兔速递"></el-option>
                <el-option value="KYE" label="跨越速运"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录入时间" prop="created_at">
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                  searchArr.created_at
                    ? searchArr.created_at[0] + '至' + searchArr.created_at[1]
                    : '请选择'
                "
                placement="top"
              >
                <div class="block">
                  <el-date-picker
                    v-model="searchArr.created_at"
                    type="daterange"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="mini"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 100%"
                    :picker-options="ysyTypeInPickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="签收时间" prop="updated_at">
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                  searchArr.updated_at
                    ? searchArr.updated_at[0] + '至' + searchArr.updated_at[1]
                    : '请选择'
                "
                placement="top"
              >
                <div class="block">
                  <el-date-picker
                    v-model="searchArr.updated_at"
                    type="daterange"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 100%"
                    size="mini"
                    :picker-options="ysyTypeInPickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="录入人" prop="exp_typeiner">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.exp_typeiner"
                placeholder="请选择"
                :options="exp_typeinerOptions"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false }"
                clearable
                @click.native="havingSome"
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="快递状态" prop="exp_status">
              <el-select
                v-model="searchArr.exp_status"
                clearable
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in exp_statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="来源" prop="exp_type">
              <el-radio-group v-model="searchArr.exp_type" size="mini">
                <el-radio-button :label="(h = 'h')">系统</el-radio-button>
                <el-radio-button :label="(q = 'q')">小程序</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="类型" prop="sor">
              <el-radio-group v-model="searchArr.sor" size="mini" @change="clearIsBuy">
                <el-radio-button label="s">发件</el-radio-button>
                <el-radio-button label="r">收件</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="快递费支付" prop="buy" v-if="searchArr.sor === 's'">
              <el-radio-group v-model="searchArr.buy" size="mini" @change="clearChildren">
                <el-radio-button label="w">我方</el-radio-button>
                <el-radio-button label="c">客户</el-radio-button>
                <el-radio-button label="d">到付</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label=""
              prop="is_buy"
              v-if="searchArr.sor === 's' && searchArr.buy === 'c'"
            >
              <el-radio v-model="searchArr.is_buy" label="1">已收取</el-radio>
              <el-radio v-model="searchArr.is_buy" label="0">未收取(我方垫付)</el-radio>
            </el-form-item>
            <el-form-item label="是否下单" prop="order_code" v-if="searchArr.sor === 's'">
              <el-radio-group v-model="searchArr.order_code" size="mini">
                <el-radio-button label="a">已下单</el-radio-button>
                <el-radio-button label="u">未下单</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="其他" prop="other">
              <el-radio-group v-model="searchArr.other" size="mini">
                <el-radio-button label="w">待认领快递</el-radio-button>
                <el-radio-button label="n">公司为空的</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: inline-block; width: 220px; float: right">
            <div style="text-align: center">查询人员服务的公司</div>
            <el-form-item label-width="0" prop="businessC">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.businessC"
                placeholder="选择业务员查询服务的公司"
                :options="businessOptionsC"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                @visible-change="loadAdminBusC"
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label-width="0" prop="kefuC">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.kefuC"
                placeholder="选择客服会计查询服务的公司"
                :options="kefuOptionsC"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                @visible-change="loadAdminKefuC"
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label-width="0" prop="jizhangC">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.jizhangC"
                placeholder="选择理票会计查询服务的公司"
                :options="jizhangOptionsC"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false,multiple: true }"
                clearable
                @visible-change="loadAdminJizhangC"
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label-width="0" prop="taxC">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.taxC"
                placeholder="选择记账报税会计查询服务的公司"
                :options="taxOptionsC"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                @visible-change="loadAdminTaxC"
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label-width="0" prop="kaipiaoC">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.kaipiaoC"
                placeholder="选择开票会计查询服务的公司"
                :options="kaipiaoOptionsC"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                @visible-change="loadAdminKaipiaoC"
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label-width="0" prop="leaderC">
              <el-cascader
                style="width: 100%"
                v-model="searchArr.leaderC"
                placeholder="选择财税负责人查询服务的公司"
                :options="leaderOptionsC"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                @visible-change="loadAdminLeaderC"
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
          </div>
          <el-form-item style="text-align: right">
            <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
            <el-button type="primary" @click="screen" size="mini">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button slot="reference" size="mini">筛选</el-button>
      </el-popover>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="expManageIn">录入</el-button>
        <a href="/exp_manage_cate">
          <el-button type="warning" size="mini">快递内容</el-button>
        </a>
        <el-button type="success" size="mini" @click="openImport">导入</el-button>
      </div>
    </div>
    <el-collapse v-model="activeNames">
      <!-- <el-collapse-item title="" name="1">
        <template slot="title">
          <span style="color: #409eff">数据统计</span>
        </template>
        <el-row style="margin-top: 0.2rem; font-size: 0.38rem" :gutter="20">
          <el-col :span="3">
            <el-card style="border-left: 4px solid; border-radius: 0">
              <p>快递总数:</p>
              <p style="margin-top: 0.15rem">{{ totalpage }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #f56c6c; border-radius: 0">
              <p>今日快递:</p>
              <p style="color: #f56c6c; margin-top: 0.15rem">
                {{ headers.day }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #e6a23c; border-radius: 0">
              <p>本月快递:</p>
              <p style="color: #e6a23c; margin-top: 0.15rem">
                {{ headers.mon }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #67c23a; border-radius: 0">
              <p>发件:</p>
              <p style="color: #67c23a; margin-top: 0.15rem">
                {{ headers.send }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p>收件:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ headers.receive }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p>确认签收:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ headers.al }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p>待认领:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ headers.wait }}
              </p>
            </el-card>
          </el-col>
        </el-row>
        <el-row style="margin-top: 0.2rem" :gutter="20">
          <el-col :span="3">
            <el-tag size="mini">我的收件:</el-tag>
          </el-col>
          <el-col :span="3" :offset="3">
            <el-tag size="mini">我的发件:</el-tag>
          </el-col>
          <el-col :span="3" :offset="3">
            <el-tag size="mini">快递费用收取单数:</el-tag>
          </el-col>
          <el-col :span="3" :offset="3">
            <el-tag size="mini">快递费用收取统计:</el-tag>
          </el-col>
        </el-row>
        <el-row style="font-size: 0.38rem" :gutter="20">
          <el-col :span="3">
            <el-card style="border-left: 4px solid; border-radius: 0">
              <p style="white-space: nowrap">今日收件:</p>
              <p style="margin-top: 0.15rem">{{ headers.my_today_r }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p style="white-space: nowrap">本月收件:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ headers.my_month_r }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid; border-radius: 0">
              <p style="white-space: nowrap">今日发件:</p>
              <p style="margin-top: 0.15rem">{{ headers.my_today_s }}</p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p style="white-space: nowrap">本月发件:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ headers.my_month_s }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #f56c6c; border-radius: 0">
              <p style="white-space: nowrap">本月未收取:</p>
              <p style="color: #f56c6c; margin-top: 0.15rem">
                {{ headers.month_unBuy }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #67c23a; border-radius: 0">
              <p style="white-space: nowrap">本月已收取:</p>
              <p style="color: #67c23a; margin-top: 0.15rem">
                {{ headers.month_buy }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #e6a23c; border-radius: 0">
              <p style="white-space: nowrap">本月已收取:</p>
              <p style="color: #e6a23c; margin-top: 0.15rem">
                {{ headers.month_money }}
              </p>
            </el-card>
          </el-col>
          <el-col :span="3">
            <el-card style="border-left: 4px solid #409eff; border-radius: 0">
              <p style="white-space: nowrap">总收取:</p>
              <p style="color: #409eff; margin-top: 0.15rem">
                {{ headers.total_money }}
              </p>
            </el-card>
          </el-col>
        </el-row>
      </el-collapse-item> -->
      <el-collapse-item title="" name="2" id="servicein">
        <template slot="title">
          <span style="color: #409eff">数据统计</span>
        </template>
        <!-- <div style="background-color: #f5f6f7">
          <div style="background-color: #ffffff; padding: 0.2rem 0">
            <el-row style="font-size: 0.3rem" :gutter="0">
              <el-col>
                <el-col
                  :span="2"
                  style="
                    border-right: 1px solid #dcdfe6;
                    text-align: center;
                    color: #909399;
                    padding: 0.3rem 0;
                  "
                >
                  <el-row style="font-size: 0.33rem">
                    <el-col>快递件数</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">今日</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.day
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">本月</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.mon
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">累计</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      totalpage
                    }}</el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="2"
                  style="
                    border-right: 1px solid #dcdfe6;
                    text-align: center;
                    color: #909399;
                    padding: 0.3rem 0;
                  "
                >
                  <el-row style="font-size: 0.33rem">
                    <el-col>发件</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">今日</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.total_today_s
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">本月</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.total_month_s
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">累计</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.send
                    }}</el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="2"
                  style="
                    border-right: 1px solid #dcdfe6;
                    text-align: center;
                    color: #909399;
                    padding: 0.3rem 0;
                  "
                >
                  <el-row style="font-size: 0.33rem">
                    <el-col>收件</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">今日</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.total_today_r
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">本月</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.total_month_r
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">累计</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.receive
                    }}</el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="3"
                  style="
                    border-right: 1px solid #dcdfe6;
                    text-align: center;
                    color: #909399;
                    padding: 0.3rem 0;
                  "
                >
                  <el-row style="font-size: 0.33rem">
                    <el-col>签收</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="70">
                    <el-col :span="4" style="white-space: nowrap"
                      >确认签收</el-col
                    >
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.al
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="70">
                    <el-col :span="4" style="white-space: nowrap"
                      >待认领</el-col
                    >
                    <el-col :span="3" style="color: #f56c6c">{{
                      headers.wait
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap"></el-col>
                    <el-col :span="3" style="color: #67c23a">&nbsp;</el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="4"
                  style="
                    border-right: 1px solid #dcdfe6;
                    text-align: center;
                    color: #909399;
                    padding: 0.3rem 0;
                  "
                >
                  <el-row style="font-size: 0.33rem">
                    <el-col>本月快递费收取单数</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="60">
                    <el-col :span="4" style="white-space: nowrap"
                      >未收取</el-col
                    >
                    <el-col :span="4" style="color: #f56c6c">{{
                      headers.month_unBuy
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="60">
                    <el-col :span="4" style="white-space: nowrap"
                      >已收取</el-col
                    >
                    <el-col :span="4" style="color: #67c23a">{{
                      headers.month_buy
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap"></el-col>
                    <el-col :span="3" style="color: #67c23a">&nbsp;</el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="4"
                  style="
                    border-right: 1px solid #dcdfe6;
                    text-align: center;
                    color: #909399;
                    padding: 0.3rem 0;
                  "
                >
                  <el-row style="font-size: 0.33rem">
                    <el-col>快递费收取统计</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">本月</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.month_money
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">累计</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.total_money
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="2" style="white-space: nowrap"></el-col>
                    <el-col :span="4" style="color: #67c23a">&nbsp;</el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="3"
                  style="
                    border-right: 1px solid #dcdfe6;
                    text-align: center;
                    color: #909399;
                    padding: 0.3rem 0;
                  "
                >
                  <el-row style="font-size: 0.33rem">
                    <el-col>快递费未收取</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">本月</el-col>
                    <el-col :span="3" style="color: #e6a23c">{{
                      headers.month_money_un
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">累计</el-col>
                    <el-col :span="3" style="color: #f56c6c">{{
                      headers.total_money_un
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap"></el-col>
                    <el-col :span="3" style="color: #67c23a">&nbsp;</el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="2"
                  style="
                    border-right: 1px solid #dcdfe6;
                    text-align: center;
                    color: #909399;
                    padding: 0.3rem 0;
                  "
                >
                  <el-row style="font-size: 0.33rem">
                    <el-col>我的发件</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">今日</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.my_today_s
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">本月</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.my_month_s
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap"></el-col>
                    <el-col :span="3" style="color: #67c23a">&nbsp;</el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="2"
                  style="
                    border-right: 1px solid #dcdfe6;
                    text-align: center;
                    color: #909399;
                    padding: 0.3rem 0;
                  "
                >
                  <el-row style="font-size: 0.33rem">
                    <el-col>我的收件</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">今日</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.my_today_r
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap">本月</el-col>
                    <el-col :span="3" style="color: #67c23a">{{
                      headers.my_month_r
                    }}</el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="40">
                    <el-col :span="4" style="white-space: nowrap"></el-col>
                    <el-col :span="3" style="color: #67c23a">&nbsp;</el-col>
                  </el-row>
                </el-col>
              </el-col>
            </el-row>
          </div>
        </div> -->
        <el-row :gutter="12">
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">快递件数</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row
                    type="flex"
                    justify="center"
                    :gutter="12"
                    class="item-row"
                    style="color: #f56c6c"
                  >
                    <el-col :span="14" style="white-space: nowrap">今日</el-col>
                    <el-col :span="10" style="color: #f56c6c">{{ headers.day }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    justify="center"
                    :gutter="12"
                    style="color: #409eff"
                  >
                    <el-col :span="14" style="white-space: nowrap">本月</el-col>
                    <el-col :span="10" style="color: #409eff">{{ headers.mon }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    justify="center"
                    :gutter="12"
                    style="color: #67c23a"
                  >
                    <el-col :span="14" style="white-space: nowrap">累计</el-col>
                    <el-col :span="10" style="color: #67c23a">{{ totalpage }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap"></el-col>
                    <el-col :span="10" style="color: "></el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">收件</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #409eff"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">今日</el-col>
                    <el-col :span="10" style="color: ">{{
                      headers.total_today_r
                    }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #67c23a"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">本月</el-col>
                    <el-col :span="10" style="color: #67c23a">{{
                      headers.total_month_r
                    }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">累计</el-col>
                    <el-col :span="10" style="color: ">{{ headers.receive }}</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">发件</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #409eff"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">今日</el-col>
                    <el-col :span="10" style="color: ">{{
                      headers.total_today_s
                    }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #f56c6c"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">本月</el-col>
                    <el-col :span="10" style="color: #f56c6c">{{
                      headers.total_month_s
                    }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">累计</el-col>
                    <el-col :span="10" style="color: ">{{ headers.send }}</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">签收</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #67c23a"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">确认签收</el-col>
                    <el-col :span="10" style="color: #67c23a">{{ headers.al }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #f56c6c"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">待认领</el-col>
                    <el-col :span="10" style="color: #f56c6c">{{ headers.wait }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap"></el-col>
                    <el-col :span="10" style="color: #67c23a">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">本月快递费收取单数</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #f56c6c"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">未收取</el-col>
                    <el-col :span="10" style="color: ">{{ headers.month_unBuy }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #67c23a"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">已收取</el-col>
                    <el-col :span="10" style="color: ">{{ headers.month_buy }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap"></el-col>
                    <el-col :span="10" style="color: ">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">快递费收取统计</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #67c23a"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">本月</el-col>
                    <el-col :span="10" style="color: ">{{ headers.month_money }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">累计</el-col>
                    <el-col :span="10" style="color: ">{{ headers.total_money }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap"></el-col>
                    <el-col :span="10" style="color: ">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="12" style="margin-top: 0.2rem">
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">快递费未收取</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #f56c6c"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">本月</el-col>
                    <el-col :span="10" style="color: ">{{
                      headers.month_money_un
                    }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">累计</el-col>
                    <el-col :span="10" style="color: ">{{
                      headers.total_money_un
                    }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap"></el-col>
                    <el-col :span="10" style="color: ">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">我的发件</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #e6a23c"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">今日</el-col>
                    <el-col :span="10" style="color: ">{{ headers.my_today_s }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #409eff"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">本月</el-col>
                    <el-col :span="10" style="color: ">{{ headers.my_month_s }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap"></el-col>
                    <el-col :span="10" style="color: ">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="4">
            <el-card shadow="hover">
              <div class="item-title">我的收件</div>
              <div class="item-title">
                <div class="item-content">
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #e6a23c"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">今日</el-col>
                    <el-col :span="10" style="color: ">{{ headers.my_today_r }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: #409eff"
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap">本月</el-col>
                    <el-col :span="10" style="color: ">{{ headers.my_month_r }}</el-col>
                  </el-row>
                  <el-row
                    type="flex"
                    class="item-row"
                    style="color: "
                    justify="center"
                    :gutter="12"
                  >
                    <el-col :span="14" style="white-space: nowrap"></el-col>
                    <el-col :span="10" style="color: ">&nbsp;</el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
    <el-dialog
      title="修改地址"
      :visible.sync="editAddressDialog"
      :modal="false"
      width="30%"
    >
      <el-form
        :model="editAddressForm"
        :rules="addressRules"
        ref="editAddressForm"
        label-width="100px"
      >
        <el-form-item label="收件人" prop="addressee">
          <el-input
            v-model="editAddressForm.addressee"
            size="mini"
            placeholder="请填写收件人"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="address_phone">
          <el-input
            v-model="editAddressForm.address_phone"
            size="mini"
            placeholder="请填写手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="收件人区域" prop="receiver_place">
          <el-select
            v-model="editAddressForm.receiver_place_pro"
            placeholder="省"
            clearable
            filterable
            size="mini"
            style="width: 100%"
            @click.native="getAddressPro"
            @change="getAddressCity"
          >
            <el-option
              v-for="item in addressProOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="editAddressForm.receiver_place_city"
            placeholder="市"
            clearable
            filterable
            size="mini"
            style="width: 100%"
            @change="getAddressTown"
          >
            <el-option
              v-for="item in addressCityOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="editAddressForm.receiver_place_town"
            placeholder="区/县"
            clearable
            filterable
            size="mini"
            style="width: 100%"
          >
            <el-option
              v-for="item in addressTownOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收件地址" prop="address">
          <el-input
            v-model="editAddressForm.address"
            size="mini"
            placeholder="请填写收件地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-top: 0.15rem; text-align: right">
        <el-button type="primary" size="mini" @click="doEdit('editAddressForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-drawer
      title="录入快递信息"
      :visible.sync="expManageIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="expruleForm"
          :rules="rules"
          ref="expruleForm"
          label-width="110px"
          class=""
        >
          <el-form-item label="类型" prop="sor">
            <el-radio-group v-model="expruleForm.sor" size="mini">
              <el-radio-button label="s">发件</el-radio-button>
              <el-radio-button label="r">收件</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="收件人(内部)"
            prop="receiver"
            v-if="expruleForm.sor === 'r'"
          >
            <el-cascader
              style="width: 100%"
              v-model="expruleForm.receiver"
              placeholder="请选择收件人"
              :options="receiverOptionsConvert"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false }"
              clearable
              filterable
              @focus="getReceiver"
              @change="getUserPhone"
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="公司名称" prop="company_id">
            <el-select
              v-model="expruleForm.company_id"
              filterable
              remote
              reserve-keyword
              placeholder="请输入公司名称筛选公司"
              size="mini"
              clearable
              :remote-method="searchRemoteCompanyMethodTypein"
              :loading="searchLoadingTypein"
              style="width: 100%"
              @change="getUserAddress"
            >
              <el-option
                v-for="searchCompany in searchCompaniesTypein"
                :key="searchCompany.id"
                :label="searchCompany.company_name"
                :value="searchCompany.id + '|' + searchCompany.company_name"
              >
              </el-option>
            </el-select>
            <div
              v-if="userAdressOptions && expruleForm.sor === 's'"
              :gutter="0"
              style="max-height: 300px; overflow: auto"
            >
              <el-row
                :gutter="0"
                v-for="(item, index) in userAdressOptions"
                :key="item.id"
                style="
                  border: 1px solid #dcdfe6;
                  border-radius: 10px;
                  padding-left: 0.2rem;
                  margin-bottom: 0.2rem;
                  cursor: pointer;
                "
                :class="{ active: cIndex == index }"
                @click.native="chooseThis(item, index)"
              >
                <el-col
                  :span="6"
                  :title="item.addressee"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                >
                  <span>收件人：</span>
                  <span style="color: #409eff">{{ item.addressee }}</span>
                </el-col>
                <el-col
                  :span="10"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                  :title="item.address_phone"
                >
                  <span>收件人电话：</span>
                  <span style="color: #67c23a">{{ item.address_phone }}</span>
                </el-col>
                <el-col
                  :span="3"
                  :offset="5"
                  style="
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    text-align: center;
                  "
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="修改地址"
                    placement="top"
                    v-if="sIndex == index"
                  >
                    <i
                      class="el-icon-edit"
                      style="color: #409eff; font-size: 0.38rem"
                      @click="openEditAddressDialog(item)"
                    ></i>
                  </el-tooltip>
                </el-col>
                <el-col
                  :span="24"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                  :title="item.pro.name + ' ' + item.city.name + ' ' + item.town.name"
                  v-if="item.pro && item.city && item.town"
                >
                  <span>区域：</span>
                  <span style="color: #e6a23c">{{
                    item.pro.name + " " + item.city.name + " " + item.town.name
                  }}</span>
                </el-col>
                <el-col
                  :span="24"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                  :title="item.pro.name + ' ' + item.city.name + ' '"
                  v-else-if="item.pro && item.city && !item.town"
                >
                  <span>区域：</span>
                  <span style="color: #e6a23c">{{
                    item.pro.name + " " + item.city.name
                  }}</span>
                </el-col>
                <el-col
                  :span="24"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                  :title="item.address"
                >
                  <span>地址：</span>
                  <span style="color: #e6a23c">{{ item.address }}</span>
                </el-col>
              </el-row>
              <el-row style="text-align: right">
                <el-popover placement="left-start" width="500" trigger="click">
                  <el-form
                    :model="addAddressForm"
                    :rules="addressRules"
                    ref="addAddressForm"
                    label-width="100px"
                  >
                    <el-form-item label="收件人" prop="addressee">
                      <el-input
                        v-model="addAddressForm.addressee"
                        size="mini"
                        placeholder="请填写收件人"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="address_phone">
                      <el-input
                        v-model="addAddressForm.address_phone"
                        size="mini"
                        placeholder="请填写手机号"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收件人区域" prop="receiver_place">
                      <el-select
                        v-model="addAddressForm.receiver_place_pro"
                        placeholder="省"
                        clearable
                        filterable
                        size="mini"
                        style="width: 100%"
                        @click.native="getAddressPro"
                        @change="getAddressCity"
                      >
                        <el-option
                          v-for="item in addressProOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="addAddressForm.receiver_place_city"
                        placeholder="市"
                        clearable
                        filterable
                        size="mini"
                        style="width: 100%"
                        @change="getAddressTown"
                      >
                        <el-option
                          v-for="item in addressCityOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="addAddressForm.receiver_place_town"
                        placeholder="区/县"
                        clearable
                        filterable
                        size="mini"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in addressTownOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="收件地址" prop="address">
                      <el-input
                        v-model="addAddressForm.address"
                        size="mini"
                        placeholder="请填写收件地址"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                  <div
                    style="margin-top: 0.15rem; text-align: right; padding-right: 0.16rem"
                  >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="saveChange('addAddressForm')"
                      >保存</el-button
                    >
                  </div>
                  <el-tag
                    size="mini"
                    @click="resetSome"
                    slot="reference"
                    style="cursor: pointer"
                    >新增地址 <i class="el-icon-plus"></i
                  ></el-tag>
                </el-popover>
              </el-row>
            </div>
          </el-form-item>
          <el-form-item label="快递公司" prop="exp_company">
            <el-select
              v-model="expruleForm.exp_company"
              placeholder="请选择快递公司"
              size="mini"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option value="SFEXPRESS" label="顺丰"></el-option>
              <el-option value="STO" label="申通"></el-option>
              <el-option value="YTO" label="圆通"></el-option>
              <el-option value="ZTO" label="中通"></el-option>
              <el-option value="HTKY" label="汇通"></el-option>
              <!-- <el-option value="HTKY" label="汇通"></el-option> -->
              <el-option value="YUNDA" label="韵达"></el-option>
              <!-- <el-option value="YUNDA" label="韵达"></el-option> -->
              <!-- <el-option value="TTKDEX" label="天天"></el-option> -->
              <el-option value="TTKDEX" label="天天"></el-option>
              <el-option value="JD" label="京东快递"></el-option>
              <el-option value="ZJS" label="宅急送"></el-option>
              <!-- <el-option value="CHINAPOST" label="EMS"></el-option> -->
              <el-option value="CHINAPOST" label="EMS"></el-option>
              <!-- <el-option value="INTMAIL" label="EMS国际"></el-option> -->
              <el-option value="INTMAIL" label="EMS国际"></el-option>
              <!-- <el-option value="DEPPON" label="德邦"></el-option> -->
              <el-option value="DEPPON" label="德邦"></el-option>
              <el-option value="HTKY" label="百世快递"></el-option>
              <!-- <el-option value="JITU" label="极兔速递"></el-option> -->
              <el-option value="JITU" label="极兔速递"></el-option>
              <el-option value="KYE" label="跨越速运"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否下单"
            prop="is_now"
            v-if="expruleForm.sor === 's' && expruleForm.exp_company === 'SFEXPRESS'"
          >
            <el-checkbox
              v-model="expruleForm.is_now"
              size="mini"
              border
              @change="cancelOrder"
              >是否现在下单</el-checkbox
            >
            <!-- @change="orderOrNot" -->
          </el-form-item>
          <el-form-item label="发件人" prop="name" v-if="expruleForm.is_now">
            <el-cascader
              style="width: 100%"
              v-model="expruleForm.name"
              placeholder="发件人"
              :options="senderOptions"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false }"
              clearable
              filterable
              @change="getPersonPhone"
              @click.native="getSender"
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="发件人手机" prop="sender_phone" v-if="expruleForm.is_now">
            <el-input
              type="number"
              v-model="expruleForm.sender_phone"
              size="mini"
              maxlength="11"
              show-word-limit
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="收件人区域"
            prop="receiver_place"
            v-if="expruleForm.is_now"
          >
            <el-select
              v-model="expruleForm.receiver_place_pro"
              placeholder="省"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @click.native="getAddressPro"
              @change="getAddressCity"
            >
              <el-option
                v-for="item in addressProOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="expruleForm.receiver_place_city"
              placeholder="市"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @change="getAddressTown"
            >
              <el-option
                v-for="item in addressCityOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="expruleForm.receiver_place_town"
              placeholder="区/县"
              clearable
              filterable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in addressTownOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="包裹数量" prop="quantity" v-if="expruleForm.is_now">
            <el-input
              type="number"
              v-model="expruleForm.quantity"
              size="mini"
              maxlength="2"
              placeholder="最多支持30件"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="快递费支付方式"
            prop="PayType"
            v-if="expruleForm.is_now && expruleForm.exp_company !== 'SFEXPRESS'"
          >
            <el-radio-group
              v-model="expruleForm.PayType"
              size="mini"
              @change="clearChildren"
            >
              <el-radio-button label="1">现付</el-radio-button>
              <el-radio-button label="2">到付</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发货地址" prop="place" v-if="expruleForm.is_now">
            <el-radio-group v-model="expruleForm.place" size="mini">
              <!-- @change="getOrder" -->
              <el-radio label="FX">奉贤</el-radio>
              <el-radio label="JA">静安</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="快递单号" prop="exp_num" v-if="!expruleForm.is_now">
            <el-input
              v-model="expruleForm.exp_num"
              size="mini"
              placeholder="请输入快递单号"
            ></el-input>
          </el-form-item>
          <el-form-item label="快递费支付" prop="buy" v-if="expruleForm.sor === 's'">
            <el-radio-group v-model="expruleForm.buy" size="mini">
              <el-radio-button label="w">我方</el-radio-button>
              <el-radio-button label="c">客户</el-radio-button>
              <el-radio-button label="d">到付</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="费用" prop="pay" v-if="expruleForm.sor === 's'">
            <el-input type="number" v-model="expruleForm.pay" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="快递费用收取"
            prop="is_buy"
            v-if="expruleForm.sor === 's' && expruleForm.buy === 'c'"
          >
            <el-radio-group v-model="expruleForm.is_buy" size="mini" id="sign">
              <el-radio-button label="1">已收取</el-radio-button>
              <el-radio-button label="0">未收取(我方垫付)</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="快递手机号" prop="exp_phone" v-if="sf">
            <el-input v-model="expruleForm.exp_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递手机号" prop="exp_phone" v-else>
            <el-input v-model="expruleForm.exp_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="收件人(客户)"
            prop="receiver_s"
            v-if="expruleForm.sor === 's'"
          >
            <el-select
              v-model="expruleForm.receiver_s"
              filterable
              remote
              reserve-keyword
              placeholder="选择收件地址自动添加收件人"
              size="mini"
              clearable
              :remote-method="searchInput"
              :loading="searchLoading"
              style="width: 100%"
              disabled
            >
              <el-option
                v-for="searchCompany in userOptions"
                :key="searchCompany.id"
                :label="
                  'id:' +
                  searchCompany.id +
                  ' 昵称:' +
                  searchCompany.name +
                  ' 性别:' +
                  searchCompany.sex
                "
                :value="searchCompany.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="手机(客户)"
            prop="receiver_phone"
            v-if="expruleForm.sor === 's'"
          >
            <el-input v-model="expruleForm.receiver_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递内容" prop="exp_content">
            <el-checkbox-group v-model="expruleForm.exp_content">
              <el-checkbox
                v-for="item in expContentOptions"
                :key="item.id"
                :label="item.category_name"
                name="exp_content"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              size="mini"
              type="textarea"
              v-model="expruleForm.remark"
              placeholder="快递备注,选择现在下单时快递公司可见！"
              style="white-space: pre"
            ></el-input>
          </el-form-item>

          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm('expruleForm')"
              >录入</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer title="" :visible.sync="printDrawer" direction="rtl" size="40%">
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem">打印面单</span>
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          ref="form"
          :model="sizeForm"
          label-width="80px"
          size="mini"
          method="POST"
          action="https://www.kdniao.com/External/PrintOrder.aspx"
        >
          <el-form-item label="请求数据">
            <el-input
              v-model="sizeForm.RequestData"
              readonly
              name="RequestData"
            ></el-input>
          </el-form-item>
          <el-form-item label="参数1">
            <el-input
              v-model="sizeForm.EBusinessID"
              readonly
              name="EBusinessID"
            ></el-input>
          </el-form-item>
          <el-form-item label="参数2">
            <el-input v-model="sizeForm.DataSign" readonly name="DataSign"></el-input>
          </el-form-item>
          <el-form-item label="参数3">
            <el-input v-model="sizeForm.IsPriview" readonly name="IsPriview"></el-input>
          </el-form-item>
          <el-form-item label="" style="text-align: right">
            <button
              type="submit"
              style="
                background-color: #409eff;
                border-radius: 5px;
                cursor: pointer;
                width: 1rem;
                color: white;
              "
            >
              打印
            </button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="expManageEditdrawer"
      :direction="direction"
      :before-close="handleClosEdit"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="expeditruleForm"
          :rules="editrules"
          ref="expeditruleForm"
          label-width="105px"
          class=""
        >
          <el-form-item label="类型" prop="sor">
            <el-radio-group v-model="expeditruleForm.sor" size="mini">
              <el-radio-button label="s">发件</el-radio-button>
              <el-radio-button label="r">收件</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="收件人(内部)"
            prop="receiver"
            v-if="expeditruleForm.sor === 'r'"
          >
            <el-cascader
              style="width: 100%"
              v-model="expeditruleForm.receiver"
              placeholder="请选择收件人"
              :options="receiverEditOptionsConvert"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false }"
              clearable
              filterable
              @focus="getReceiverEdit"
              @change="getUserPhoneEdit"
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="公司名称" prop="company_id">
            <el-select
              v-model="expeditruleForm.company_id"
              filterable
              remote
              reserve-keyword
              placeholder="请输入公司名称筛选公司"
              size="mini"
              clearable
              :remote-method="searchRemoteCompanyMethodEdit"
              :loading="searchLoadingEdit"
              style="width: 100%"
              @change="getUserAddress"
            >
              <el-option
                v-for="searchCompany in searchCompaniesEdit"
                :key="searchCompany.id"
                :label="searchCompany.company_name"
                :value="searchCompany.id + '|' + searchCompany.company_name"
              >
              </el-option>
            </el-select>
            <div v-if="userAdressOptions && expeditruleForm.sor === 's'" :gutter="0">
              <el-row
                :gutter="0"
                v-for="(item, index) in userAdressOptions"
                :key="item.id"
                style="
                  border: 1px solid #dcdfe6;
                  border-radius: 10px;
                  padding-left: 0.2rem;
                  margin-bottom: 0.2rem;
                  cursor: pointer;
                "
                :class="{ active: ceIndex == index }"
                @click.native="chooseThisE(item, index)"
              >
                <el-col
                  :span="6"
                  :title="item.addressee"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                >
                  <span>收件人：</span>
                  <span style="color: #409eff">{{ item.addressee }}</span>
                </el-col>
                <el-col
                  :span="10"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                  :title="item.address_phone"
                >
                  <span>收件人电话：</span>
                  <span style="color: #67c23a">{{ item.address_phone }}</span>
                </el-col>
                <el-col
                  :span="3"
                  :offset="5"
                  style="
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    text-align: center;
                  "
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="修改地址"
                    placement="top"
                    v-if="seIndex == index"
                  >
                    <i
                      class="el-icon-edit"
                      style="color: #409eff; font-size: 0.38rem"
                      @click="openEditAddressDialog(item)"
                    ></i>
                  </el-tooltip>
                </el-col>
                <el-col
                  :span="24"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                  :title="item.pro.name + ' ' + item.city.name + ' ' + item.town.name"
                  v-if="item.pro && item.city && item.town"
                >
                  <span>区域：</span>
                  <span style="color: #e6a23c">{{
                    item.pro.name + " " + item.city.name + " " + item.town.name
                  }}</span>
                </el-col>
                <el-col
                  :span="24"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                  :title="item.pro.name + ' ' + item.city.name"
                  v-else-if="item.pro && item.city && !item.town"
                >
                  <span>区域：</span>
                  <span style="color: #e6a23c">{{
                    item.pro.name + " " + item.city.name
                  }}</span>
                </el-col>
                <el-col
                  :span="24"
                  style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
                  :title="item.address"
                >
                  <span>地址：</span>
                  <span style="color: #e6a23c">{{ item.address }}</span>
                </el-col>
              </el-row>
              <el-row style="text-align: right">
                <el-popover placement="left-start" width="500" trigger="click">
                  <el-form
                    :model="addAddressForm"
                    :rules="addressRules"
                    ref="addAddressForm"
                    label-width="100px"
                  >
                    <el-form-item label="收件人" prop="addressee">
                      <el-input
                        v-model="addAddressForm.addressee"
                        size="mini"
                        placeholder="请填写收件人"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="address_phone">
                      <el-input
                        v-model="addAddressForm.address_phone"
                        size="mini"
                        placeholder="请填写手机号"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收件人区域" prop="receiver_place">
                      <el-select
                        v-model="addAddressForm.receiver_place_pro"
                        placeholder="省"
                        clearable
                        filterable
                        size="mini"
                        style="width: 100%"
                        @click.native="getAddressPro"
                        @change="getAddressCity"
                      >
                        <el-option
                          v-for="item in addressProOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="addAddressForm.receiver_place_city"
                        placeholder="市"
                        clearable
                        filterable
                        size="mini"
                        style="width: 100%"
                        @change="getAddressTown"
                      >
                        <el-option
                          v-for="item in addressCityOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="addAddressForm.receiver_place_town"
                        placeholder="区/县"
                        clearable
                        filterable
                        size="mini"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in addressTownOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="收件地址" prop="address">
                      <el-input
                        v-model="addAddressForm.address"
                        size="mini"
                        placeholder="请填写收件地址"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                  <div
                    style="margin-top: 0.15rem; text-align: right; padding-right: 0.16rem"
                  >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="saveChangeE('addAddressForm')"
                      >保存</el-button
                    >
                  </div>
                  <el-tag
                    size="mini"
                    @click="resetSome"
                    slot="reference"
                    style="cursor: pointer"
                    >新增地址 <i class="el-icon-plus"></i
                  ></el-tag>
                </el-popover>
              </el-row>
            </div>
          </el-form-item>
          <el-form-item label="快递公司" prop="exp_company">
            <el-select
              v-model="expeditruleForm.exp_company"
              placeholder="请选择快递公司"
              size="mini"
              style="width: 100%"
            >
              <!-- disabled -->
              <el-option value="SFEXPRESS" label="顺丰"></el-option>
              <el-option value="STO" label="申通"></el-option>
              <el-option value="YTO" label="圆通"></el-option>
              <el-option value="ZTO" label="中通"></el-option>
              <el-option value="HTKY" label="汇通"></el-option>
              <el-option value="YUNDA" label="韵达"></el-option>
              <el-option value="TTKDEX" label="天天"></el-option>
              <el-option value="JD" label="京东快递"></el-option>
              <el-option value="ZJS" label="宅急送"></el-option>
              <el-option value="CHINAPOST" label="EMS"></el-option>
              <el-option value="INTMAIL" label="EMS国际"></el-option>
              <el-option value="DEPPON" label="德邦"></el-option>
              <el-option value="HTKY" label="百世快递"></el-option>
              <el-option value="JITU" label="极兔速递"></el-option>
              <el-option value="KYE" label="跨越速运"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" prop="exp_num">
            <el-input v-model="expeditruleForm.exp_num" size="mini" disabled></el-input>
            <!-- disabled -->
          </el-form-item>
          <el-form-item label="快递费支付" prop="buy" v-if="expeditruleForm.sor === 's'">
            <el-radio-group v-model="expeditruleForm.buy" size="mini">
              <el-radio-button label="w">我方</el-radio-button>
              <el-radio-button label="c">客户</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="费用" prop="pay" v-if="expeditruleForm.sor === 's'">
            <el-input type="number" v-model="expeditruleForm.pay" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="快递费用收取"
            prop="is_buy"
            v-if="expeditruleForm.sor === 's' && expeditruleForm.buy === 'c'"
          >
            <el-radio-group v-model="expeditruleForm.is_buy" size="mini" id="sign">
              <el-radio-button label="1">已收取</el-radio-button>
              <el-radio-button label="0">未收取(我方垫付)</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="快递手机号" prop="exp_phone" v-if="editsf">
            <el-input v-model="expeditruleForm.exp_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递手机号" prop="exp_phone" v-else>
            <el-input v-model="expeditruleForm.exp_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="收件人" prop="receiver_s" v-if="expruleForm.sor === 's'">
            <el-input v-model="expruleForm.receiver_s" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="收件人手机"
            prop="receiver_phone"
            v-if="expruleForm.sor === 's'"
          >
            <el-input v-model="expruleForm.receiver_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="收件人(客户)"
            prop="receiver_s"
            v-if="expeditruleForm.sor === 's'"
          >
            <el-select
              v-model="expeditruleForm.receiver_s"
              filterable
              remote
              reserve-keyword
              placeholder="选择收件地址自动添加"
              size="mini"
              clearable
              :remote-method="searchInput"
              :loading="searchLoading"
              style="width: 100%"
              disabled
            >
              <el-option
                v-for="searchCompany in userOptions"
                :key="searchCompany.id"
                :label="
                  'id:' +
                  searchCompany.id +
                  ' 昵称:' +
                  searchCompany.name +
                  ' 性别:' +
                  searchCompany.sex
                "
                :value="searchCompany.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="手机(客户)"
            prop="receiver_phone"
            v-if="expeditruleForm.sor === 's'"
          >
            <el-input
              v-model="expeditruleForm.receiver_phone"
              size="mini"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="快递内容" prop="exp_content">
            <el-checkbox-group v-model="expeditruleForm.exp_content">
              <el-checkbox
                v-for="item in editExpContentOptions"
                :key="item.id"
                :label="item.category_name"
                name="exp_content"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              size="mini"
              type="textarea"
              v-model="expeditruleForm.remark"
              placeholder="快递备注"
              style="white-space: pre"
            ></el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editsubmitForm('expeditruleForm')"
              >保存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="签收快递"
      :visible.sync="expManageReceivedrawer"
      :direction="direction"
      :before-close="handleQClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="receiveruleForm"
          :rules="receiverules"
          ref="receiveruleForm"
          label-width="100px"
          class=""
        >
          <el-form-item label="公司名称" prop="company_id">
            <el-select
              v-model="receiveruleForm.company_id"
              filterable
              remote
              reserve-keyword
              placeholder="请输入公司名称筛选公司"
              size="mini"
              clearable
              :remote-method="searchRemoteCompanyMethodReceive"
              :loading="searchLoadingReceive"
              style="width: 100%"
            >
              <el-option
                v-for="searchCompany in searchCompaniesReceive"
                :key="searchCompany.id"
                :label="searchCompany.company_name"
                :value="searchCompany.id + '|' + searchCompany.company_name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递公司" prop="exp_company">
            <el-select
              v-model="receiveruleForm.exp_company"
              placeholder="请选择快递公司"
              size="mini"
              style="width: 100%"
            >
              <el-option value="SFEXPRESS" label="顺丰"></el-option>
              <el-option value="STO" label="申通"></el-option>
              <el-option value="YTO" label="圆通"></el-option>
              <el-option value="ZTO" label="中通"></el-option>
              <el-option value="HTKY" label="汇通"></el-option>
              <el-option value="YUNDA" label="韵达"></el-option>
              <el-option value="TTKDEX" label="天天"></el-option>
              <el-option value="JD" label="京东快递"></el-option>
              <el-option value="ZJS" label="宅急送"></el-option>
              <el-option value="CHINAPOST" label="EMS"></el-option>
              <el-option value="INTMAIL" label="EMS国际"></el-option>
              <el-option value="DEPPON" label="德邦"></el-option>
              <el-option value="HTKY" label="百世快递"></el-option>
              <el-option value="JITU" label="极兔速递"></el-option>
              <el-option value="KYE" label="跨越速运"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" prop="exp_num">
            <el-input v-model="receiveruleForm.exp_num" size="mini" disabled></el-input>
          </el-form-item>
          <el-form-item label="快递手机号" prop="exp_phone" v-if="receivesf">
            <el-input v-model="receiveruleForm.exp_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递手机号" prop="exp_phone" v-else>
            <el-input v-model="receiveruleForm.exp_phone" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="快递内容" prop="exp_content">
            <el-checkbox-group v-model="receiveruleForm.exp_content">
              <el-checkbox
                v-for="item in signExpContentOptions"
                :key="item.id"
                :label="item.category_name"
                name="exp_content"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- <el-form-item label="快递状态" prop="exp_status">
              <el-input v-model="receiveruleForm.exp_status" size="mini"></el-input>
            </el-form-item> -->
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="receivesubmitForm('receiveruleForm')"
              >确认签收</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title=""
      :visible.sync="importDrawer"
      direction="rtl"
      size="50%"
      :before-close="handleClose_importDrawer"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem; font-weight: bold"
          >导入顺丰快递运费单</span
        >
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <!-- action="https://weixin.qiyehuo.com/api/sfexp/upfile" -->
        <!-- action="/api/sfexp/upfile" -->
        <el-upload
          action="https://weixin.qiyehuo.com/api/sfexp/upfile"
          :headers="headers_u"
          ref="uploadMutiple"
          :file-list="fileList"
          :limit="limit"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
          :show-file-list="false"
          style="display: inline-block"
        >
          <el-button size="mini" type="primary">导入</el-button>
        </el-upload>
        <el-button
          size="mini"
          type="warning"
          style="margin-left: 0.5rem"
          v-if="Object.values(diff_exp_num).length"
          @click="exportSFOrder"
          >导出</el-button
        >
        <div v-if="diff_exp_num" style="margin-top: 0.5rem">
          <span style="color: #409eff; font-size: 0.38rem">
            {{
              excel_date + "共有" + Object.values(diff_exp_num).length + "条，不在系统："
            }}
          </span>
          <!-- <el-row
            style="margin-top: 0.2rem; font-size: 0.35rem"
            :gutter="20"
            v-for="(item, index) in diff_exp_num"
            :key="index"
          >
            <el-col>{{ item }}</el-col>
          </el-row> -->
          <el-table
            max-height="650"
            :data="allSFOrderData"
            style="width: 100%; margin-top: 10px"
            border
            size="mini"
            :header-cell-style="{
              background: '#ecf4ff',
              color: '#333',
              fontWeight: '900',
              fontSize: '0.28rem',
            }"
          >
            <el-table-column prop="0" label="序号" width="80" fixed="left">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="1" label="日期" fixed="left"> </el-table-column>
            <el-table-column prop="2" label="运单号码" fixed="left"> </el-table-column>
            <el-table-column prop="3" label="寄件地区"> </el-table-column>
            <el-table-column prop="4" label="到件地区"> </el-table-column>
            <el-table-column prop="5" label="对方公司名称"> </el-table-column>
            <el-table-column prop="6" label="计费重量"> </el-table-column>
            <el-table-column prop="7" label="产品类型"> </el-table-column>
            <el-table-column prop="8" label="付款方式"> </el-table-column>
            <el-table-column prop="9" label="费用(元)"> </el-table-column>
            <el-table-column prop="10" label="折扣/促销"> </el-table-column>
            <el-table-column prop="11" label="应付金额"> </el-table-column>
            <el-table-column prop="12" label="经手人"> </el-table-column>
            <el-table-column prop="13" label="增值费用"> </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>
    <div class="middle-table">
      <el-table
        height="calc(100vh - 316px)"
        :data="expManageData"
        style="width: 100%; margin-top: 10px"
        border
        size="mini"
        :header-cell-style="{
          background: '#ecf4ff',
          color: '#333',
          fontWeight: '900',
          fontSize: '0.28rem',
        }"
      >
        <el-table-column fixed="left" prop="company_name" label="公司名称" width="220">
          <template slot-scope="scope">
            <span
              v-if="scope.row.company_name"
              style="color: #409eff; font-size: 0.28rem; cursor: pointer"
              @click="openCompanyCom(scope.row)"
            >
              {{ scope.row.company_name }}
            </span>
            <el-tooltip
              v-if="scope.row.company_name"
              class="item"
              effect="dark"
              content="复制"
              placement="top"
              ><i
                class="el-icon-document-copy"
                style="margin-left: 0.1rem; cursor: pointer"
                @click="copySome(scope.row.company_name)"
              ></i
            ></el-tooltip>
            <el-tooltip
              v-else
              class="item"
              effect="dark"
              content="点击补充公司"
              placement="top"
            >
              <el-popover placement="left-start" width="300" trigger="click">
                <div style="color: #409eff; margin-bottom: 0.2rem">补充公司名称</div>
                <el-select
                  v-model="addCompany"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入公司名称筛选公司"
                  size="mini"
                  clearable
                  :remote-method="addCompanySearch"
                  :loading="searchLoading"
                  style="width: 100%"
                >
                  <el-option
                    v-for="searchCompany in addCompanyoptions"
                    :key="searchCompany.id"
                    :label="searchCompany.company_name"
                    :value="searchCompany.id"
                  >
                  </el-option>
                </el-select>
                <div style="margin-top: 0.15rem; text-align: right">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="saveChange_addCompany(scope.row.id)"
                    >保存</el-button
                  >
                </div>
                <span slot="reference" style="color: #f56c6c; cursor: pointer">
                  无公司或待补充
                </span>
              </el-popover>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="" label="类型" width="130">
          <template slot-scope="scope">
            <span v-if="scope.row.sor === 's'">
              <el-tag size="mini" type="danger">发件</el-tag>
              <p v-if="scope.row.sor === 's' && scope.row.buy === 'c'">
                费用付款方：客户
              </p>
              <p v-if="scope.row.sor === 's' && scope.row.buy === 'w'">
                费用付款方：我方
              </p>
              <p v-if="scope.row.sor === 's' && scope.row.buy === 'd'">
                费用付款方式：到付
              </p>
              <p v-if="scope.row.sor === 's' && scope.row.is_buy === 1">
                费用状态：已收取
              </p>
              <p v-if="scope.row.sor === 's' && !scope.row.is_buy === 0">
                费用状态：
                <span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="点击修改状态"
                    placement="top"
                  >
                    <el-popconfirm
                      title="确定客户快递费用已经收取了吗？"
                      @onConfirm="storePay"
                    >
                      <span
                        slot="reference"
                        @click="paied(scope.row.id)"
                        style="color: #f56c6c; cursor: pointer"
                        >未收取</span
                      >
                    </el-popconfirm>
                  </el-tooltip>
                </span>
              </p>
            </span>
            <span v-if="scope.row.sor === 'r'">
              <el-tag size="mini" type="warning">收件</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="exp_company" label="快递公司" width="210">
          <template slot-scope="scope">
            <p>{{ scope.row.exp_company }}</p>
            <p>
              <el-tooltip :content="scope.row.exp_num" placement="top">
                <el-link
                  class="hide-style"
                  type="primary"
                  @click="handelGetLogistics(scope.row)"
                  >{{ scope.row.exp_num }}</el-link
                >
              </el-tooltip>
            </p>
            <p>
              <span v-if="scope.row.issign == 1 && scope.row.exp_status != '确认收到'">
                已经签收
              </span>
              <span v-else>
                {{ scope.row.exp_status }}
              </span>
              <el-button
                type="success"
                size="mini"
                style="margin-left: 20px"
                v-if="
                  receivePower(
                    scope.row.exp_typeiner_id,
                    scope.row.bind_id,
                    scope.row.exp_status,
                    scope.row.receiver,
                    scope.row.sor,
                    scope.row.qs_receiver
                  )
                "
                @click="receiveRow(scope.$index, expManageData)"
              >
                签收
              </el-button>
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="exp_num" label="快递单号" width="180">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.exp_num" placement="top">
            <el-link
              class="hide-style"
              type="primary"
              @click="handelGetLogistics(scope.row)"
              >{{ scope.row.exp_num }}</el-link
            >
          </el-tooltip>
        </template>
      </el-table-column> -->
        <el-table-column prop="exp_phone" label="快递手机号" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.type === '小程序' && scope.row.sor === 's'">{{
              scope.row.receiver_phone
            }}</span>
            <span v-else>{{ scope.row.exp_phone }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="收件人" width="130">
          <template slot-scope="scope">
            <span v-if="scope.row.sor === 's' && scope.row.type === '小程序'">{{
              "(内部)" + scope.row.qs_receiver
            }}</span>
            <span v-if="scope.row.sor === 'r' && scope.row.receiver_name">{{
              "(内部)" + scope.row.receiver_name
            }}</span>
            <span v-if="scope.row.sor === 's' && scope.row.receiver_s">{{
              "(客户)" + scope.row.receiver_s
            }}</span>
            <span
              v-if="
                !scope.row.receiver_s && !scope.row.receiver_name && scope.row.sor === 'r'
              "
            >
              <span>无收件人</span>
              <span style="margin-left: 0.3rem">
                <el-tooltip class="item" effect="dark" content="认领快递" placement="top">
                  <el-popconfirm title="确定认领吗？" @onConfirm="doConfirm">
                    <el-button
                      type="primary"
                      slot="reference"
                      @click="toConfirm(scope.row.id)"
                      icon="el-icon-user"
                      size="mini"
                      circle
                      style="font-size: 0.28rem"
                    ></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="exp_content" label="快递内容" width="300">
          <template slot-scope="scope">
            <!-- <el-tooltip placement="top-start" popper-class="atooltip"> -->
            <div>{{ scope.row.exp_content }}</div>
            <div slot="content">{{ scope.row.exp_content }}</div>
            <!-- </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column prop="exp_typeiner" label="录入人" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.type !== '小程序'">{{ scope.row.exp_typeiner }}</span>
            <span
              v-if="
                scope.row.type === '小程序' && scope.row.user && scope.row.user.nickname
              "
              >{{ "(客户)" + scope.row.user.nickname }}</span
            >
            <span v-if="scope.row.type === '小程序' && scope.row.sor === 's'">{{
              "(客户)" + scope.row.exp_typeiner
            }}</span>
            <p>
              {{ scope.row.type }}
            </p>
            <p>
              <!-- {{ scope.row.created_at }} -->
              <date-formatter :date-value="scope.row.created_at"></date-formatter>
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="exp_status" label="快递状态" width="220">
        <template slot-scope="scope">
          <span>
            {{ scope.row.exp_status }}
          </span>
          <el-button
            type="success"
            size="mini"
            style="margin-left: 20px"
            v-if="
              receivePower(
                scope.row.exp_typeiner_id,
                scope.row.bind_id,
                scope.row.exp_status,
                scope.row.receiver,
                scope.row.sor
              )
            "
            @click="receiveRow(scope.$index, expManageData)"
          >
            签收
          </el-button>
        </template>
      </el-table-column> -->
        <!-- <el-table-column prop="type" label="来源" width="100"> </el-table-column>
      <el-table-column prop="created_at" label="快递信息录入时间" width="180">
      </el-table-column> -->
        <el-table-column prop="updated_at" label="最后编辑时间" width="140">
          <template slot-scope="scope">
            <date-formatter :date-value="scope.row.updated_at"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="220">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="修改" placement="top">
              <el-button
                @click.native.prevent="editRow(scope.$index, expManageData)"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                circle
              >
              </el-button>
            </el-tooltip>
            <!-- @click.native.prevent="cancelRow(scope.row)" -->
            <!-- :disabled="!scope.row.order_code || scope.row.type === '小程序'" -->
            <el-tooltip class="item" effect="dark" content="取消订单" placement="top">
              <el-popconfirm title="确定取消吗？" @onConfirm="cancelRow(scope.row)">
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-s-release"
                  circle
                  slot="reference"
                  :disabled="!scope.row.order_code || scope.row.type === '小程序'"
                  style="margin-left: 0.16rem; margin-right: 0.16rem"
                >
                </el-button>
              </el-popconfirm>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="打印面单" placement="top">
              <el-button
                @click.native="printRow(scope.row)"
                type="success"
                size="mini"
                icon="el-icon-printer"
                circle
                :disabled="!scope.row.order_code || scope.row.type === '小程序'"
              >
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="企业微信群聊天记录"
              placement="top"
            >
              <el-button
                type="warning"
                @click="handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company)"
                size="mini"
                icon="el-icon-s-comment"
                circle
                :disabled="scope.row.wx_work_chat_com ? false : true"
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-phone-outline"
                circle
                @click="handCallLogsOpen(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-drawer
      title="物流信息"
      direction="rtl"
      :visible.sync="expressInfoDrawer"
      :before-close="handExpressInfoClose"
      size="40%"
    >
      <div style="padding: 0 0.2rem">
        <el-timeline v-if="expressInfo.length > 0">
          <el-timeline-item
            class="logistics"
            v-for="(item, index) in expressInfo"
            :key="index"
            :timestamp="item.time"
          >
            {{ item.status }}
          </el-timeline-item>
        </el-timeline>
        <div style="text-align: center" v-else>
          <p>
            <i
              class="el-icon-info"
              style="font-size: 1rem; color: #909399 !important"
            ></i>
          </p>
          <p style="margin-top: 0.35rem">
            <span style="color: #909399">信息提示</span>
          </p>
          <p style="margin-top: 0.28rem">
            <span style="color: #909399; font-size: 0.3rem"
              >系统未查到该快递记录，快递号可能有误，请检查修改！</span
            >
          </p>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkchatCompany"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="聊天记录"
      :visible.sync="chatDrawer"
      direction="rtl"
      :before-close="handleChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat :chatId="chatId" :chatName="chatCompany"></chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info
            :companyId="companyComId"
            :checkType="expCheckType"
          ></company-info>
        </el-row>
      </div>
    </el-drawer>
    <div class="page-footer">
      <el-pagination
        class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="totalpage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="expManagePerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Chat from "common/Chat";
import CallLogs from "common/CallLogs";
import WxWorkChat from "common/WxWorkChat";
import CompanyInfo from "common/CompanyInfo";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import DateFormatter from "common/DateFormatter";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "ExpManage",
  mixins: [fscDate],
  components: { CompanyInfo, Chat, CallLogs, WxWorkChat, DateFormatter },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value !== "") {
        var reg = /^1[3456789]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请输⼊有效的⼿机号码"));
        }
      }
      callback();
    };
    var checkExpNum = (rule, value, callback) => {
      const title = /^[A-Z]*[a-z]*[0-9]*$/;
      if (!title.test(value)) {
        callback(new Error("快递单号只能是字母，数字！"));
      } else {
        callback();
      }
    };
    return {
      expCheckType: this.$feedBackConfig.post_matter,
      townNone: false,
      allSFOrderData: "",
      typein_pickerOptions: {
        shortcuts: [
          {
            text: "上月",
            onClick(picker) {
              const oDate = new Date();
              var year = oDate.getFullYear();
              var month = oDate.getMonth();
              var start, end;
              if (month === 0) {
                year--;
                start = new Date(year, 11, 1);
                end = new Date(year, 11, 31, 23, 59, 59);
              } else {
                start = new Date(year, month - 1, 1);
                end = new Date(year, month, 0, 23, 59, 59);
              }
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      diff_exp_num: "",
      excel_date: "",
      headers_u: {
        Authorization: localStorage.getItem("token"),
      },
      fileList: [],
      fileList_e: [],
      limit: 1,
      importDrawer: false,
      loginer_name: "",
      printData: "",
      sizeForm: {
        RequestData: "",
        EBusinessID: "",
        DataSign: "",
        IsPriview: "",
        sender: "",
        sender_phone: "",
        place: "",
        receiver_s: "",
        receiver_phone: "",
        receiver_place_pro: "",
        receiver_place_city: "",
        receiver_place_town: "",
        receiver_address: "",
        id: "",
      },
      printDrawer: false,
      proCityOptions: [],
      senderOptions: [],
      placeRadio: false,
      wxChatDrawer: false,
      company: null,
      wxWorkChatId: null,
      wxWorkchatCompany: null,
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      callLogsDrawer: false,
      chatDrawer: false,
      chatId: null,
      chatCompany: null,
      payId: null,
      ceIndex: null,
      confirmId: null,
      confirmVisible: false,
      secondLoadId: null,
      editAddressId: null,
      editAddressDialog: false,
      editAddressForm: {
        addressee: "",
        address_phone: "",
        address: "",
        receiver_place_pro: "",
        receiver_place_city: "",
        receiver_place_town: "",
      },
      sIndex: null,
      seIndex: null,
      activeNames: [""],
      signExpContentOptions: [],
      addCompanyoptions: [],
      addCompany: "",
      addAddressForm: {
        addressee: "",
        address_phone: "",
        address: "",
        receiver_place_pro: "",
        receiver_place_city: "",
        receiver_place_town: "",
      },
      addressRules: {
        addressee: [{ required: true, message: "请输入收件人", trigger: "blur" }],
        address_phone: [
          { required: true, message: "请输入收件人手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入收件人姓名", trigger: "blur" }],
      },
      editExpContentOptions: [],
      cIndex: null,
      expressInfoDrawer: false,
      expressInfo: [],
      expManageData: [],
      expManageIndrawer: false,
      expManageReceivedrawer: false,
      direction: "rtl",
      addressProOptions: [],
      addressCityOptions: [],
      addressTownOptions: [],
      typein: false,
      expruleForm: {
        wxOrder: "",
        order_code: "",
        PayType: "",
        quantity: "",
        receiver_place_pro: "",
        receiver_place_city: "",
        receiver_place_town: "",
        receiver_address: "",
        sender_phone: "",
        name: "",
        place: "",
        is_now: "",
        exp_num: "",
        company_id: "",
        company_name: "",
        exp_company: "",
        exp_phone: "",
        domains: [
          {
            value: "",
          },
        ],
        exp_content: [],
        exp_receiver: "",
        delivery: false,
        sor: "",
        receiver_phone: "",
        receiver_s: "",
        pay: "",
        buy: "",
        remark: "",
        is_buy: "",
      },
      expeditruleForm: {
        company_id: "",
        company_name: "",
        exp_company: "",
        exp_phone: "",
        exp_num: "",
        domains: [
          {
            value: "",
          },
        ],
        exp_content: [],
        delivery: false,
        sor: "",
        receiver_phone: "",
        receiver_s: "",
        buy: "",
        is_buy: "",
        pay: "",
        remark: "",
        receiver_place_pro: "",
        receiver_place_city: "",
        receiver_place_town: "",
        receiver_address: "",
      },
      receiveruleForm: {
        company_id: "",
        company_name: "",
        exp_company: "",
        exp_phone: "",
        domains: [
          {
            value: "",
          },
        ],
        exp_content: [],
        delivery: false,
      },
      userAdressOptions: "",
      companyData: [],
      userOptions: [],
      expManagePerPage: 30,
      totalpage: 0,
      currentPage1: 0,
      selectCompany: "",
      searchCompanies: [],
      searchCompaniesTypein: [],
      searchCompaniesEdit: [],
      searchCompaniesReceive: [],
      q: "",
      h: "",
      searchArr: {
        order_code: "",
        company_id: "",
        exp_company: "",
        created_at: "",
        updated_at: "",
        exp_typeiner: "",
        exp_status: "",
        exp_type: "",
        sor: "",
        other: "",
        buy: "",
        is_buy: "",
        businessC: "",
        kefuC: "",
        jizhangC: "",
        taxC: "",
        kaipiaoC: "",
        leaderC: "",
      },
      businessOptionsC: [],
      kefuOptionsC: [],
      jizhangOptionsC: [],
      taxOptionsC: [],
      kaipiaoOptionsC: [],
      leaderOptionsC: [],
      companyInfoDrawer: false,
      searchLoading: false,
      searchLoadingTypein: false,
      searchLoadingEdit: false,
      searchLoadingReceive: false,
      visible: false,
      exp_numLoading: false,
      exp_numArr: [],
      expManageEditdrawer: false,
      needIndex: "",
      needIndex_receive: "",
      needId: "",
      needId_receive: "",
      loginer: "",
      index: "",
      headers: "",
      exp_typeinerOptions: [],
      receiverOptions: [],
      receiverEditOptions: [],
      companyComId: null,
      expContentOptions: [],
      addtionData: { value: "无", label: "未知" },
      exp_statusOptions: [
        { label: "已经发出" },
        { label: "前台签收" },
        { label: "确认收到" },
      ],
      rules: {
        pay: [{ required: true, message: "请填写费用", trigger: "blur" }],
        is_buy: [{ required: true, message: "请选择快递费是否收取", trigger: "blur" }],
        buy: [{ required: true, message: "请选择快递费支付方", trigger: "blur" }],
        receiver_phone: [
          { required: true, message: "请填写手机(客户)", trigger: "blur" },
        ],
        receiver_s: [{ required: true, message: "请填写收件人(客户)", trigger: "blur" }],
        company_id: [{ message: "请选择公司名称", trigger: "blur" }],
        exp_num: [
          { required: true, message: "请输入快递单号", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
          { validator: checkExpNum, trigger: "blur" },
        ],
        sor: [{ required: true, message: "请选择类型", trigger: "blur" }],
        exp_phone: [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        // exp_content: [
        //   { message: '请选择快递内容', trigger: 'change' }
        // ],
        exp_company: [{ required: true, message: "请选择快递公司", trigger: "change" }],
        // exp_phone: [{ message: '请选择快递公司', trigger: 'change' }]
      },
      editrules: {
        pay: [{ required: true, message: "请填写费用", trigger: "blur" }],
        is_buy: [{ required: true, message: "请选择快递费是否收取", trigger: "blur" }],
        buy: [{ required: true, message: "请选择快递费支付方", trigger: "blur" }],
        receiver_s: [{ required: true, message: "请填写收件人(客户)", trigger: "blur" }],
        company_id: [{ message: "请选择公司名称", trigger: "blur" }],
        exp_num: [
          { required: false, message: "请输入快递单号", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" },
        ],
        // exp_content: [
        //   { required: true, message: '请选择快递内容', trigger: 'change' }
        // ],
        exp_company: [{ required: true, message: "请选择快递公司", trigger: "change" }],
        exp_phone: [
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        receiver_phone: [
          { required: true, message: "请填写手机(客户)", trigger: "blur" },
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
      },
      receiverules: {
        company_id: [{ message: "请选择公司名称", trigger: "blur" }],
        exp_num: [
          { required: false, message: "请输入快递单号", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" },
        ],
        // exp_content: [
        //   { required: true, message: '请选择快递内容', trigger: 'change' }
        // ],
        exp_company: [{ message: "请选择快递公司", trigger: "change" }],
        exp_phone: [{ message: "请填写快递手机号", trigger: "change" }],
      },
    };
  },
  mounted() {
    this.loadExpmanage();
  },
  computed: {
    newExpManageData: function () {
      var arr = this.expManageData;
      var result = [];
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].company_name]) {
          result.push(arr[i]);
          obj[arr[i].company_name] = true;
        }
      }
      return result;
    },
    sf: function () {
      if (this.expruleForm.exp_company === "SFEXPRESS") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rules.exp_phone = [
          { required: true, message: "请输入手机号", trigger: "change" },
        ];
        return true;
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.rules.exp_phone = [{ message: "请输入手机号", trigger: "change" }];
      }
    },
    editsf: function () {
      if (
        this.expeditruleForm.exp_company === "SFEXPRESS" ||
        this.expeditruleForm.exp_company === "顺丰"
      ) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.editrules.exp_phone = [
          { required: true, message: "请输入手机号", trigger: "change" },
        ];
        return true;
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.editrules.exp_phone = [{ message: "请输入手机号", trigger: "change" }];
      }
    },
    receivesf: function () {
      if (
        this.receiveruleForm.exp_company === "SFEXPRESS" ||
        this.receiveruleForm.exp_company === "顺丰"
      ) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.receiverules.exp_phone = [
          { required: true, message: "请输入手机号", trigger: "change" },
        ];
        return true;
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.receiverules.exp_phone = [{ message: "请输入手机号", trigger: "change" }];
      }
    },
    collapse() {
      return this.$store.state.collapse;
    },
    receiverOptionsConvert() {
      return [...this.receiverOptions, this.addtionData];
    },
    receiverEditOptionsConvert() {
      return [...this.receiverEditOptions, this.addtionData];
    },
  },
  methods: {
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    exportSFOrder() {
      this.$axios
        .post(
          "api/sfexp/exportdiff",
          {
            expNums: this.diff_exp_num,
          },
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = this.excel_date + "顺丰运单不在系统统计.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
        })
        .catch();
    },
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    date(shijianchuo) {
      // shijianchuo是整数，否则要parseInt转换
      var time = new Date(shijianchuo);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      // var h = time.getHours();
      // var mm = time.getMinutes();
      // var s = time.getSeconds();
      return (
        y + "-" + this.add0(m) + "-" + this.add0(d)
        //  +
        // " " +
        // this.add0(h) +
        // ":" +
        // this.add0(mm) +
        // ":" +
        // this.add0(s)
      );
    },
    // 获取指定日期所在月的第一天和最后一天
    getfirstDateAndlastDate(dateC) {
      var dateStr = dateC;
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month > 12) {
        month = 1;
        year++;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var monthLastDay = new Date(year, month, 0).getDate();
      var firstDate = year + "-" + month + "-" + "01";
      var lastDate = year + "-" + month + "-" + monthLastDay;
      return [firstDate, lastDate];
    },
    handleClose_importDrawer(done) {
      this.diff_exp_num = "";
      this.excel_date = "";
      done();
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.allSFOrderData = res.all_data;
        this.diff_exp_num = res.data;
        this.excel_date = res.date;
        this.$message.success(res.msg);
        this.$refs.uploadMutiple.clearFiles();
        this.fileList = [];
        this.needUrl = [];
        this.change = false;
      }
    },
    getdif(file) {
      this.$axios
        .post("/api/sfexp/retdif", {
          file,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg);
          }
        })
        .catch();
    },
    beforeAvatarUpload(file) {
      const isXls =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isXls) {
        // console.log('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        // console.log('application/vnd.ms-excel')
        // this.$message.error('仅支持xls、xlsx格式的文件!')
        // return false
      }
    },
    openImport() {
      this.importDrawer = true;
    },
    printRow(row) {
      // this.printDrawer = true
      this.$axios
        .get("api/expmanage/printorder?id=" + row.id, {
          params: {
            order_code: row.order_code,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.sizeForm.RequestData = data.data.RequestData;
            this.sizeForm.EBusinessID = data.data.EBusinessID;
            this.sizeForm.DataSign = data.data.DataSign;
            this.sizeForm.IsPriview = data.data.IsPriview;
            this.sizeForm.id = row.id;
            let newPage = this.$router.resolve({
              path: "/exp_print",
              query: this.sizeForm,
            });
            window.open(newPage.href, "_blank");
          }
        });
    },
    cancelRow(row) {
      this.$axios
        .delete("api/expmanage/cancelorder?id=" + row.id, {
          params: {
            exp_num: row.exp_num,
            order_code: row.order_code,
            exp_company: row.exp_company,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.loadExpmanage();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getAddressTown(pid) {
      this.townNone = false;
      this.editAddressForm.receiver_place_town = "";
      this.$axios.get("api/expmanage/getaddresstown?pid=" + pid).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.addressTownOptions = data.data;
          if (data.data.length === 0) {
            this.townNone = true;
          }
        }
      });
    },
    getAddressCity(pid) {
      this.editAddressForm.receiver_place_city = "";
      this.editAddressForm.receiver_place_town = "";
      this.$axios.get("api/expmanage/getaddresscity?pid=" + pid).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.addressCityOptions = data.data;
        }
      });
    },
    getAddressPro() {
      this.$axios.get("api/expmanage/getaddresspro").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.addressProOptions = data.data;
        }
      });
    },
    getPro() {
      this.$axios.get("api/expmanage/getpro").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.proCityOptions = data.data;
        }
      });
    },
    getLoginer() {
      this.$axios.get("api/expmanage/getloginer").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.expruleForm.name = data.data;
          this.getPersonPhone(data.data);
        }
      });
    },
    getPersonPhone(val) {
      this.$axios.get("api/expmanage/getpersonphone?userId=" + val, {}).then((res) => {
        this.placeRadio = false;
        const { data } = res;
        if (data.code === 1) {
          this.expruleForm.sender_phone = data.data;
        }
      });
    },
    cancelOrder(val) {
      if (!val) {
        this.placeRadio = true;
        this.expruleForm.name = "";
        this.expruleForm.sender_phone = "";
      } else {
        this.placeRadio = false;
        this.getSender();
        this.getLoginer();
      }
    },
    getOrder() {
      if (!this.expruleForm.name) {
        this.$message.error("请填写发件人！");
        return false;
      }
      if (!this.expruleForm.sender_phone) {
        this.$message.error("请填写发件人手机号！");
        return false;
      }
      var reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.expruleForm.sender_phone)) {
        this.$message.error("请填写正确的发件人手机号！");
        return false;
      }
      if (
        !this.expruleForm.receiver_s ||
        !this.expruleForm.receiver_phone ||
        !this.expruleForm.receiver_address
      ) {
        this.$message.error("请先选择地址！");
        return false;
      }
      if (
        !this.expruleForm.receiver_place_pro ||
        !this.expruleForm.receiver_place_city ||
        !this.expruleForm.receiver_place_town
      ) {
        this.$message.error("请选择完整收件人区域省市区！");
        return false;
      }
      if (this.expruleForm.exp_content.length <= 0) {
        this.$message.error("请选择快递内容！");
        return false;
      }
      if (!this.expruleForm.quantity) {
        this.$message.error("请填写包裹数量！");
        return false;
      }
      if (this.expruleForm.quantity > 30) {
        this.$message.error("包裹数量不能超过30！");
        return false;
      }
      if (!this.expruleForm.place) {
        this.$message.error("请选择发货地址！");
        return false;
      }
      var expCompany = this.expruleForm.exp_company;
      var place = this.expruleForm.place;
      var receiver = this.expruleForm.receiver_s;
      var receiverPhone = this.expruleForm.receiver_phone;
      var receiverAddress = this.expruleForm.receiver_address;
      var name = this.expruleForm.name;
      var senderPhone = this.expruleForm.sender_phone;
      var receiverPlacePro = this.expruleForm.receiver_place_pro;
      var receiverPlaceCity = this.expruleForm.receiver_place_city;
      var receiverPlaceTown = this.expruleForm.receiver_place_town;
      var expContent = this.expruleForm.exp_content;
      var quantity = this.expruleForm.quantity;
      var remark = this.expruleForm.remark;
      var PayType = this.expruleForm.PayType;
      var buy = this.expruleForm.buy;
      this.$axios
        .get("api/expmanage/getorder", {
          params: {
            expCompany,
            place,
            receiver,
            receiverPhone,
            receiverAddress,
            name,
            senderPhone,
            receiverPlacePro,
            receiverPlaceCity,
            receiverPlaceTown,
            expContent,
            quantity,
            remark,
            PayType,
            buy,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.expruleForm.exp_num = data.data.LogisticCode;
            this.expruleForm.order_code = data.data.OrderCode;
            // 生成小程序支付订单
            if (
              this.expruleForm.buy === "c" &&
              this.expruleForm.pay > 0 &&
              this.expruleForm.is_buy === "0"
            ) {
              this.createOrder(
                this.expruleForm.pay,
                this.expruleForm.company_id,
                this.expruleForm.remark
              );
            }
            this.submitForm_e("expruleForm");
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    createOrder(money, companyId, remark) {
      this.$axios
        .post("api/expmanage/createOrder", { money, companyId, remark })
        .then(({ data }) => {
          if (data.code === 1) {
            this.expruleForm.wxOrder = data.data;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    createOrder_e(money, companyId, remark) {
      this.$axios
        .post("api/expmanage/createOrder", { money, companyId, remark })
        .then(({ data }) => {
          if (data.code === 1) {
            this.expruleForm.wxOrder = data.data;
            this.submitForm_e("expruleForm");
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    orderOrNot(val) {
      if (val) {
        this.$confirm("确认下单？")
          .then((_) => {
            this.getOrder();
          })
          .catch((_) => {
            this.expruleForm.is_now = false;
          });
      } else {
        this.$confirm("确认取消订单？")
          .then((_) => {
            alert(222);
          })
          .catch((_) => {
            this.expruleForm.is_now = true;
          });
      }
    },
    loadAdminUserNew() {
      // return this.$axios.get('api/expmanage/getreceiver')
      return this.$axios.get("api/admin/user/branch");
    },
    loadAdminLeaderC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.leaderOptionsC = data.data;
        }
      });
    },
    loadAdminKaipiaoC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.kaipiaoOptionsC = data.data;
        }
      });
    },
    loadAdminTaxC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.taxOptionsC = data.data;
        }
      });
    },
    loadAdminJizhangC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.jizhangOptionsC = data.data;
        }
      });
    },
    loadAdminKefuC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.kefuOptionsC = data.data;
        }
      });
    },
    loadAdminBusC() {
      this.loadAdminUserNew().then(({ data }) => {
        if (data.code === 1) {
          this.businessOptionsC = data.data;
        }
      });
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    loadExpmanage(query) {
      if (!query) query = "";
      var perPage = this.expManagePerPage;
      var expcompany = this.searchArr.exp_company;
      var expnum = this.searchArr.exp_num;
      var createdat = this.searchArr.created_at;
      var updatedat = this.searchArr.updated_at;
      var exptypeiner = this.searchArr.exp_typeiner;
      var expstatus = this.searchArr.exp_status;
      var exptype = this.searchArr.exp_type;
      var sor = this.searchArr.sor;
      var other = this.searchArr.other;
      var buy = this.searchArr.buy;
      var isBuy = this.searchArr.is_buy;
      var businessC = this.searchArr.businessC;
      var kefuC = this.searchArr.kefuC;
      var jizhangC = this.searchArr.jizhangC;
      var taxC = this.searchArr.taxC;
      var kaipiaoC = this.searchArr.kaipiaoC;
      var leaderC = this.searchArr.leaderC;
      var orderCode = this.searchArr.order_code;
      this.$axios
        .get("/api/expmanage/gettable?page=" + this.currentPage1, {
          params: {
            query,
            expcompany,
            expnum,
            createdat,
            updatedat,
            exptypeiner,
            expstatus,
            exptype,
            perPage,
            sor,
            other,
            buy,
            isBuy,
            businessC,
            kefuC,
            jizhangC,
            taxC,
            kaipiaoC,
            leaderC,
            orderCode,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.expManageData = data.data.data;
            this.totalpage = data.data.total;
            this.loginer = data.loginer;
            this.loginer_name = data.loginer_name;
            this.headers = data.count;
          }
        })
        .catch();
    },
    expManageIn() {
      this.expContentOptions = [];
      this.expManageIndrawer = true;
      this.$axios.get("api/expmanage/getcate").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.expContentOptions = data.data;
        }
      });
    },
    editLoadExpContent() {
      this.expContentOptions = [];
      this.$axios.get("api/expmanage/getcate").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.editExpContentOptions = data.data;
        }
      });
    },
    signLoadExpContent() {
      this.expContentOptions = [];
      this.$axios.get("api/expmanage/getcate").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.signExpContentOptions = data.data;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm("expruleForm");
          this.addAddressForm.addressee = "";
          this.addAddressForm.address = "";
          this.addAddressForm.address_phone = "";
          this.userAdressOptions = [];
          this.cIndex = null;
          this.typein = false;
          this.townNone = false;
          this.placeRadio = false;
          done();
        })
        .catch((_) => {});
    },
    handleQClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClosEdit(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm("expeditruleForm");
          this.addAddressForm.addressee = "";
          this.addAddressForm.address = "";
          this.addAddressForm.address_phone = "";
          this.userAdressOptions = [];
          this.ceIndex = null;
          done();
        })
        .catch((_) => {});
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (this.expruleForm.exp_phone !== "") {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(this.expruleForm.exp_phone)) {
            this.$message.error("请输⼊有效的⼿机号码");
            return false;
          }
        }
        if (this.expruleForm.receiver_phone !== "") {
          var re = /^1[3456789]\d{9}$/;
          if (!re.test(this.expruleForm.receiver_phone)) {
            this.$message.error("请输⼊有效的⼿机号码");
            return false;
          }
        }
        if (valid) {
          if (this.expruleForm.is_now) {
            this.getOrder();
          } else {
            if (
              this.expruleForm.buy === "c" &&
              this.expruleForm.pay > 0 &&
              this.expruleForm.is_buy === "0"
            ) {
              this.createOrder_e(
                this.expruleForm.pay,
                this.expruleForm.company_id,
                this.expruleForm.remark
              );
            } else {
              this.$axios
                .post("/api/expmanage/expmanagein", {
                  company_name: this.expruleForm.company_id.split("|")[1],
                  company_id: this.expruleForm.company_id.split("|")[0],
                  exp_company: this.expruleForm.exp_company,
                  exp_num: this.expruleForm.exp_num,
                  exp_phone: this.expruleForm.exp_phone,
                  exp_content: this.expruleForm.exp_content,
                  exp_status: this.expruleForm.exp_status,
                  receiver: this.expruleForm.receiver,
                  receiver_s: this.expruleForm.receiver_s,
                  sor: this.expruleForm.sor,
                  receiver_phone: this.expruleForm.receiver_phone,
                  buy: this.expruleForm.buy,
                  pay: this.expruleForm.pay,
                  remark: this.expruleForm.remark,
                  is_buy: this.expruleForm.is_buy,
                })
                .then((res) => {
                  const { data } = res;
                  if (data.code === 1) {
                    this.$message.success(data.msg);
                    this.expManageIndrawer = false;
                    this.userAdressOptions = [];
                    this.cIndex = null;
                    this.typein = false;
                    this.resetForm("expruleForm");
                    this.loadExpmanage();
                  }
                })
                .catch();
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm_e(formName) {
      this.$refs[formName].validate((valid) => {
        if (this.expruleForm.exp_phone !== "") {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(this.expruleForm.exp_phone)) {
            this.$message.error("请输⼊有效的⼿机号码");
            return false;
          }
        }
        if (this.expruleForm.receiver_phone !== "") {
          var re = /^1[3456789]\d{9}$/;
          if (!re.test(this.expruleForm.receiver_phone)) {
            this.$message.error("请输⼊有效的⼿机号码");
            return false;
          }
        }
        if (valid) {
          this.$axios
            .post("/api/expmanage/expmanagein", {
              company_name: this.expruleForm.company_id.split("|")[1],
              company_id: this.expruleForm.company_id.split("|")[0],
              exp_company: this.expruleForm.exp_company,
              exp_num: this.expruleForm.exp_num,
              exp_phone: this.expruleForm.exp_phone,
              exp_content: this.expruleForm.exp_content,
              exp_status: this.expruleForm.exp_status,
              receiver: this.expruleForm.receiver,
              receiver_s: this.expruleForm.receiver_s,
              sor: this.expruleForm.sor,
              receiver_phone: this.expruleForm.receiver_phone,
              buy: this.expruleForm.buy,
              pay: this.expruleForm.pay,
              remark: this.expruleForm.remark,
              is_buy: this.expruleForm.is_buy,
              order_code: this.expruleForm.order_code,
              name: this.expruleForm.name,
              sender_phone: this.expruleForm.sender_phone,
              place: this.expruleForm.place,
              receiver_place_pro: this.expruleForm.receiver_place_pro,
              receiver_place_city: this.expruleForm.receiver_place_city,
              receiver_place_town: this.expruleForm.receiver_place_town,
              receiver_address: this.expruleForm.receiver_address,
              wx_order: this.expruleForm.wxOrder,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.expManageIndrawer = false;
                this.userAdressOptions = [];
                this.cIndex = null;
                this.typein = false;
                this.resetForm("expruleForm");
                this.loadExpmanage();
              }
            })
            .catch();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editsubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (this.expeditruleForm.exp_phone !== "") {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(this.expeditruleForm.exp_phone)) {
            this.$message.error("请输⼊有效的⼿机号码");
            return false;
          }
        }
        if (valid) {
          this.expeditruleForm.id = this.needId;
          this.$axios
            .put(
              "/api/expmanage/doexpmanageedit",
              // id: this.needId
              this.expeditruleForm
            )
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.expManageEditdrawer = false;
                this.resetForm("expeditruleForm");
                this.userAdressOptions = [];
                this.ceIndex = null;
                this.loadExpmanage();
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    receivesubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .put("/api/expmanage/doexpmanageedit", {
              id: this.needId_receive,
              company_id: this.receiveruleForm.company_id,
              exp_company: this.receiveruleForm.exp_company,
              exp_phone: this.receiveruleForm.exp_phone,
              exp_content: this.receiveruleForm.exp_content,
              received: true,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message.success(data.msg);
                this.expManageReceivedrawer = false;
                this.loadExpmanage();
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.visible = false;
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      var index = this.expruleForm.domains.indexOf(item);
      if (index !== -1) {
        this.expruleForm.domains.splice(index, 1);
      }
    },
    addDomain() {
      this.expruleForm.domains.push({
        value: "",
        key: Date.now(),
      });
    },
    handleCurrentChange(val) {
      this.currentPage1 = val;
      this.loadExpmanage();
    },
    searchRemoteCompanyMethodEdit(query) {
      if (query !== "") {
        this.searchLoadingEdit = true;
        setTimeout(() => {
          this.searchLoadingEdit = false;
          this.searchArrItemCompanysEdit(query);
        }, 200);
      } else {
        this.searchCompaniesEdit = [];
      }
    },
    searchRemoteCompanyMethodReceive(query) {
      if (query !== "") {
        this.searchLoadingReceive = true;
        setTimeout(() => {
          this.searchLoadingReceive = false;
          this.searchArrItemCompanysReceive(query);
        }, 200);
      } else {
        this.searchCompaniesReceive = [];
      }
    },
    searchRemoteCompanyMethodTypein(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanysTypein(query);
        }, 200);
      } else {
        this.searchCompaniesTypein = [];
      }
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        this.searchArrItemCompanys(query);
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchInput(query) {
      if (query !== "") {
        this.searchLoading = true;
        this.searchInputItem(query);
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.userOptions = [];
      }
    },
    searchInputItem(query) {
      this.$axios.get("api/expmanage/getuser?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.userOptions = data.data;
        }
      });
    },
    addCompanySearch(query) {
      if (query !== "") {
        this.searchLoading = true;
        this.searchInputItem_addCompany(query);
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.addCompanyoptions = [];
      }
    },
    searchInputItem_addCompany(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.addCompanyoptions = data.data.companies;
        }
      });
    },
    searchRemoteexp_numMethod(query) {
      if (query !== "") {
        this.exp_numLoading = true;
        this.searchArrItemexp_num(query);
        setTimeout(() => {
          this.exp_numLoading = false;
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemexp_num(query) {
      this.$axios.get("/api/expmanage/exp_num?exp_num=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.exp_numArr = data.data;
        }
      });
    },
    handleSearchExp_numChange(val) {
      this.searchArr.exp_num = val;
      this.loadExpmanage();
    },
    searchArrItemCompanysEdit(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompaniesEdit = data.data.companies;
        }
      });
    },
    searchArrItemCompanysReceive(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompaniesReceive = data.data.companies;
        }
      });
    },
    searchArrItemCompanysTypein(query) {
      this.$axios.get("/api/admin/searchCompany_a?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompaniesTypein = data.data.companies;
        }
      });
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange(val) {
      this.loadExpmanage(val);
    },
    screen() {
      var query = this.searchArr.company_id;
      this.currentPage1 = 1;
      this.visible = false;
      this.loadExpmanage(query);
    },
    editRow(index, data) {
      this.getReceiverEdit();
      this.editLoadExpContent();
      var id = data[index].id;
      this.needIndex = index;
      this.needId = id;
      this.expManageEditdrawer = true;
      this.$axios.get("/api/expmanage/expmanageedit?id=" + id).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.expeditruleForm.company_name1 = data.data.company_id;
          this.expeditruleForm.company_id = data.data.company_name;
          this.expeditruleForm.exp_company = data.data.exp_company;
          this.expeditruleForm.exp_num = data.data.exp_num;
          this.expeditruleForm.exp_phone = data.data.exp_phone;
          this.expeditruleForm.exp_content = data.data.exp_content;
          this.expeditruleForm.sor = data.data.sor;
          this.expeditruleForm.buy = data.data.buy;
          if (data.data.receiver) {
            this.expeditruleForm.receiver = Number(data.data.receiver);
          }
          this.expeditruleForm.remark = data.data.remark;
          this.expeditruleForm.pay = data.data.pay;
          if (
            data.data.receiver_s !== "" ||
            data.data.receiver_s !== 0 ||
            data.data.receiver_s !== null
          ) {
            this.expeditruleForm.receiver_s = data.data.receiver_s;
          }
          this.expeditruleForm.receiver_phone = data.data.receiver_phone;
          this.expeditruleForm.is_buy = data.data.is_buy;
        }
      });
    },
    receiveRow(index, data) {
      this.signLoadExpContent();
      var id = data[index].id;
      this.needIndex_receive = index;
      this.needId_receive = id;
      this.expManageReceivedrawer = true;
      this.$axios.get("/api/expmanage/expmanageedit?id=" + id).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.receiveruleForm.company_name1 = data.data.company_id;
          this.receiveruleForm.company_id = data.data.company_name;
          this.receiveruleForm.exp_company = data.data.exp_company;
          this.receiveruleForm.exp_num = data.data.exp_num;
          this.receiveruleForm.exp_phone = data.data.exp_phone;
          this.receiveruleForm.exp_content = data.data.exp_content;
        }
      });
    },
    havingSome() {
      // this.$axios.get('api/expmanage/getreceiver')
      this.$axios.get("api/admin/user/branch").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.exp_typeinerOptions = data.data;
        }
      });
    },
    getSender() {
      // this.$axios.get('api/expmanage/getreceiver')
      this.$axios.get("api/admin/user/branch").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.senderOptions = data.data;
        }
      });
    },
    receivePower(typein, bind, status, receiver, sor, qs) {
      if (
        (this.loginer === typein && status !== "确认收到" && sor === "r") ||
        (this.loginer === bind && status !== "确认收到" && sor === "r") ||
        (!receiver && status !== "确认收到" && sor === "r") ||
        (this.loginer_name === qs && status !== "确认收到")
      ) {
        return true;
      }
      if (status === "确认收到") {
        return false;
      }
    },
    getReceiver() {
      this.$axios.get("/api/admin/user/branch").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.receiverOptions = data.data;
        }
      });
    },
    getReceiverEdit() {
      this.$axios.get("/api/admin/user/branch").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.receiverEditOptions = data.data;
        }
      });
    },
    // getReceiver () {
    //   this.$axios.get('/api/expmanage/getreceiver')
    //   .then(res => {
    //     const { data } = res
    //     if (data.code === 1) {
    //       data.data.unshift({ id: null, username: '未知' })
    //       this.receiverOptions = data.data
    //     }
    //   })
    // },
    // getReceiverEdit () {
    //   this.$axios.get('/api/expmanage/getreceiver')
    //   .then(res => {
    //     const { data } = res
    //     if (data.code === 1) {
    //       data.data.unshift({ id: 0, username: '未知' })
    //       this.receiverEditOptions = data.data
    //     }
    //   })
    // },
    openCompanyCom(row) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyComId = row.company_id;
      });
    },
    handleSizeChange(val) {
      this.expManagePerPage = val;
      this.loadExpmanage();
    },
    handExpressInfoClose(done) {
      this.expressInfo = [];
      this.loadExpmanage();
      done();
    },
    handelGetLogistics(express) {
      this.$axios
        .get(
          "api/expmanage/getexp?exp_num=" +
            express.exp_num +
            "&exp_company=" +
            express.exp_company +
            "&exp_phone=" +
            express.exp_phone +
            "&id=" +
            express.id
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 1) {
            this.expressInfo = data.data;
            this.expressInfoDrawer = true;
          }
        });
    },
    getUserAddress(id) {
      this.secondLoadId = id;
      this.userAdressOptions = [];
      this.expruleForm.receiver_s = "";
      this.expruleForm.exp_phone = "";
      this.expruleForm.receiver_phone = "";
      this.cIndex = null;
      if (id) {
        this.$axios.get("api/expmanage/getuseraddress?id=" + id).then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.userAdressOptions = data.data;
          }
        });
      }
    },
    chooseThis(item, index) {
      this.cIndex = index;
      this.sIndex = index;
      this.expruleForm.receiver_s = item.addressee;
      this.expruleForm.receiver_phone = item.address_phone;
      this.expruleForm.receiver_place_pro = item.pro ? item.pro.name : "";
      this.expruleForm.receiver_place_city = item.city ? item.city.name : "";
      this.expruleForm.receiver_place_town = item.town ? item.town.name : "";
      this.expruleForm.receiver_address = item.address;
      this.expruleForm.exp_phone = item.address_phone;
    },
    chooseThisE(item, index) {
      this.ceIndex = index;
      this.seIndex = index;
      this.expeditruleForm.receiver_s = item.addressee;
      this.expeditruleForm.receiver_phone = item.address_phone;
      this.expeditruleForm.receiver_place_pro = item.pro ? item.pro.name : "";
      this.expeditruleForm.receiver_place_city = item.city ? item.city.name : "";
      this.expeditruleForm.receiver_place_town = item.town ? item.town.name : "";
      this.expeditruleForm.exp_phone = item.address_phone;
      this.expeditruleForm.receiver_address = item.address;
    },
    saveChange(formName) {
      if (!this.expruleForm.company_id) {
        this.$message.warning("请先选择公司！");
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (
          !this.addAddressForm.receiver_place_pro ||
          !this.addAddressForm.receiver_place_city ||
          (!this.addAddressForm.receiver_place_town && this.townNone === false)
        ) {
          this.$message.error("请选择完整收件人区域省市区！");
          return false;
        }
        if (valid) {
          this.$axios
            .post(
              "api/expmanage/storeuseraddress?company_id=" + this.expruleForm.company_id,
              this.addAddressForm
            )
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                var myEvent = new Event("click");
                document.dispatchEvent(myEvent);
                this.addAddressForm.addressee = "";
                this.addAddressForm.address = "";
                this.addAddressForm.address_phone = "";
                this.addAddressForm.receiver_place_pro = "";
                this.addAddressForm.receiver_place_city = "";
                this.addAddressForm.receiver_place_town = "";
                this.townNone = false;
                this.$message.success(data.msg);
                this.getUserAddress(this.expruleForm.company_id);
              } else {
                this.$message.error(data.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    saveChangeE(formName) {
      if (!this.expeditruleForm.company_id) {
        this.$message.warning("请先选择公司！");
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (
          !this.addAddressForm.receiver_place_pro ||
          !this.addAddressForm.receiver_place_city ||
          (!this.addAddressForm.receiver_place_town && this.townNone === false)
        ) {
          this.$message.error("请选择完整收件人区域省市区！");
          return false;
        }
        if (valid) {
          this.$axios
            .post(
              "api/expmanage/storeuseraddress?company_id=" +
                this.expeditruleForm.company_id,
              this.addAddressForm
            )
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                var myEvent = new Event("click");
                document.dispatchEvent(myEvent);
                this.$message.success(data.msg);
                this.addAddressForm.addressee = "";
                this.addAddressForm.address = "";
                this.addAddressForm.address_phone = "";
                this.addAddressForm.receiver_place_pro = "";
                this.addAddressForm.receiver_place_city = "";
                this.addAddressForm.receiver_place_town = "";
                this.townNone = false;
                this.getUserAddress(this.expeditruleForm.company_id);
              } else {
                this.$message.error(data.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    resetSome() {
      this.cIndex = null;
      this.expruleForm.receiver_s = "";
      this.expruleForm.receiver_phone = "";
    },
    saveChange_addCompany(id) {
      if (this.addCompany) {
        this.$axios
          .put("api/expmanage/singleaddcompany", {
            id,
            company_id: this.addCompany,
          })
          .then((res) => {
            const { data } = res;
            if (data.code === 1) {
              var myEvent = new Event("click");
              document.dispatchEvent(myEvent);
              this.$message.success(data.msg);
              this.loadExpmanage();
              this.addCompany = "";
            } else {
              this.$message.error(data.msg);
            }
          });
      }
    },
    clearChildren(val) {
      if (val === "w") {
        this.searchArr.pay = "";
      }
    },
    openEditAddressDialog(item) {
      this.getAddressPro();
      this.getAddressCity(item.receiver_place_pro);
      this.getAddressTown(item.receiver_place_city);
      this.editAddressId = item.id;
      this.editAddressForm.addressee = item.addressee;
      this.editAddressForm.address_phone = item.address_phone;
      this.editAddressForm.receiver_place_pro = item.receiver_place_pro;
      this.editAddressForm.receiver_place_city = item.receiver_place_city;
      this.editAddressForm.receiver_place_town = item.receiver_place_town;
      this.editAddressForm.address = item.address;
      this.editAddressDialog = true;
    },
    doEdit(formName) {
      if (this.editAddressId) {
        this.$refs[formName].validate((valid) => {
          if (
            !this.editAddressForm.receiver_place_pro ||
            !this.editAddressForm.receiver_place_city ||
            (!this.editAddressForm.receiver_place_town && this.townNone === false)
          ) {
            this.$message.error("请选择完整收件人区域省市区！");
            return false;
          }
          if (valid) {
            this.editAddressForm.id = this.editAddressId;
            this.$axios
              .put("api/expmanage/editaddress", this.editAddressForm)
              .then((res) => {
                const { data } = res;
                if (data.code === 1) {
                  this.$message.success(data.msg);
                  this.editAddressDialog = false;
                  this.editAddressId = null;
                  this.townNone = false;
                  this.getUserAddress(this.secondLoadId);
                } else {
                  this.$message.error(data.msg);
                }
              });
          } else {
            return false;
          }
        });
      }
    },
    toConfirm(id) {
      this.confirmId = id;
    },
    doConfirm() {
      this.$axios.put("api/expmanage/confirm", { id: this.confirmId }).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          var myEvent = new Event("click");
          document.dispatchEvent(myEvent);
          this.$message.success(data.msg);
          this.confirmId = null;
          this.loadExpmanage();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    clearIsBuy(val) {
      if (val === "r") {
        this.searchArr.buy = "";
        this.searchArr.is_buy = "";
        this.searchArr.order_code = "";
      }
    },
    paied(id) {
      this.payId = id;
    },
    storePay() {
      if (this.payId) {
        this.$axios.put("api/expmanage/storepay", { id: this.payId }).then((res) => {
          const { data } = res;
          if (data.code === 1) {
            var myEvent = new Event("click");
            document.dispatchEvent(myEvent);
            this.$message.success(data.msg);
            this.payId = null;
            this.loadExpmanage();
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    getUserPhone(id) {
      if (id) {
        this.$axios.get("api/expmanage/getuserphone?id=" + id).then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.expruleForm.exp_phone = data.data;
          }
        });
      }
    },
    getUserPhoneEdit(id) {
      if (id) {
        this.$axios.get("api/expmanage/getuserphone?id=" + id).then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.expeditruleForm.exp_phone = data.data;
          }
        });
      }
    },
    handleChatOpen(chat, companyName) {
      if (chat) {
        this.chatDrawer = true;
        setTimeout(() => {
          this.chatId = chat.chat_id;
          this.chatCompany = companyName;
        });
      }
    },
    handleChatBeforeClose(done) {
      this.clearChatsData();
      done();
    },
    clearChatsData() {
      this.chatId = "";
      this.chatName = "";
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company_name;
        if (row.user) this.callPhone.push(row.user.phone);
        if (row.docking_phone) this.callPhone3.push(row.docking_phone);
        if (row.tyc_orders.length > 0) {
          for (var i = 0; i < row.tyc_orders.length; i++) {
            if (
              row.tyc_orders[i].customer_phone &&
              this.callPhone1.indexOf(row.tyc_orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.tyc_orders[i].customer_phone);
            }
            if (
              row.tyc_orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.tyc_orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.tyc_orders[i].corporate_phone);
            }
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  },
};
</script>
<style scoped>
.expManage {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.expManage >>> .el-collapse-item__wrap {
  position: fixed;
  width: -webkit-fill-available;
  z-index: 222 !important;
}

.middle-table {
  z-index: 1;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 25px;
  text-align: right;
}

.middle-table {
  z-index: 1;
}

.el-radio {
  margin-top: 0.2rem;
}

.el-date-editor.el-input {
  width: 3.8rem !important;
}
.active {
  border: 1.2px solid #000000 !important;
}
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

#sign >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background-color: red;
  border-color: red;
  -webkit-box-shadow: red;
  box-shadow: red;
}
.notBuy {
  color: #fff;
  background-color: red;
  border-color: red;
  -webkit-box-shadow: red;
  box-shadow: red;
}

#servicein >>> .el-collapse-item__wrap {
  will-change: height;
  background-color: #fff;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: none;
}
.item-title {
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/pages/exp_manage/ExpManage.vue